import { useFormik } from 'formik';
import { Link } from 'react-router-dom';
import { handlePostLogin } from '../../../api/auth';
import ErrorMsg, { ErrorApiMsg, SuccessApiMsg } from './error-msg';
import { loginSchema } from './validation-schema';
import React, { useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { useGoogleReCaptcha } from  'react-google-recaptcha-v3';

const LoginForm = () => {
  
  const [apiErrors, setApiErrors] = useState(null);
  const [apiSuccess, setApiSuccess] = useState(null);
  const navigate = useNavigate();
  const [isSubmiting, setIsSubmiting] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  
  const handleReCaptchaVerify = useCallback(async () => {
    
    if (!executeRecaptcha) {
      console.log('executeRecaptcha not yet available');
      return;
    }
    
    const token = await executeRecaptcha('signup');
    
    return token;
    
  }, [executeRecaptcha]);
  
  // login form
  const handleOnSubmit = async (values, { resetForm }) => {
    
    console.log('handleOnSubmit => ' + isSubmiting);

    // if (isSubmiting) return;
    
    setIsSubmiting(true);
    
    const token = await handleReCaptchaVerify();
    
    console.log('token => ' + token);
    
    if (!token) {
      setApiErrors("Erro ao verificar reCAPTCHA.");
      setIsSubmiting(false);
      return;
    }
    
    handlePostLogin({
      "email": values.email, 
      "password": values.password,
      "recaptchaToken": token,
    }).then(res => {
      
      setIsSubmiting(false); 
      
      console.log(res)
      console.log(typeof res.exception)
      
      if (res.error || typeof res.exception != 'undefined') {
        
        if (typeof res.error == 'undefined') {
          setApiErrors('Erro, não foi possível processar o login.');
        } else {
          setApiErrors(res.error);
        }
        
      } else {
        
        if (res.success.message == 'Por favor confirme seu e-mail, clicando no link recém enviado a sua caixa de entrada.') {
          
          setApiSuccess(res.success.message);
          resetForm();
          
        } else {
          
          localStorage.setItem('items', JSON.stringify(res.data));
          setApiSuccess('Sucesso! Aguarde..');
          resetForm();
          navigate("/meus-cursos");
          
        }
        
      }
      
    });
    
  }
  
  // use formik
  const { handleChange, handleSubmit, handleBlur, errors, values, touched } = useFormik({
    initialValues: { email: '', password: '' },
    validationSchema: loginSchema,
    onSubmit: handleOnSubmit,
  });
  
  return (
    <form onSubmit={handleSubmit}>
    <div className="sign__input-wrapper mb-25">
    <h5>E-mail</h5>
    <div className="sign__input">
    <input type="text" value={values.email} onChange={handleChange}
    onBlur={handleBlur} placeholder="Endereço e-mail" name='email' />
    <i className="fal fa-envelope"></i>
    </div>
    {touched.email && <ErrorMsg error={errors.email} />}
    </div>
    <div className="sign__input-wrapper mb-10">
    <h5>Senha</h5>
    <div className="sign__input">
    <input value={values.password} onChange={handleChange}
    onBlur={handleBlur} name="password" type="password" placeholder="Senha" />
    <i className="fal fa-lock"></i>
    </div>
    {touched.password && <ErrorMsg error={errors.password} />}
    </div>
    <div className="sign__action d-sm-flex justify-content-between mb-30">
    
    <div className="sign__forgot">
    <Link to="/esqueci-a-senha">Esqueceu sua senha?</Link>
    </div>
    </div>
    <button className="e-btn  w-100"> { (isSubmiting) ? <span><i className="fal fa-spinner"></i></span> : 'Entrar' }</button>
    
    {apiErrors && <ErrorApiMsg error={apiErrors} />}
    
    {apiSuccess && <SuccessApiMsg msg={apiSuccess} />}
    
    <div className="sign__new text-center mt-20">
    <p>Novo por aqui? <Link to="/inscrever-se">Cadastre-se</Link></p>
    </div>
    </form>
  );
};

export default LoginForm;